
import { Injectable } from '@angular/core';
import { CotacaoRamoService } from './cotacao-ramo.service';
import { UtilsService } from '../utils.service';
import { IntegracaoConstants } from 'src/app/constants/integracao';
import { CalcsResults } from 'src/app/models/calculos/calcs-results.model';
import { CalcEntity } from 'src/app/models/calcEntity.model';
import { CalcVida } from 'src/app/models/calcVida.model';

import { RecalculoService } from 'recalculo';
import { ApiUsuarioService } from '../api-usuario.service';
import { LeadsConstants } from 'src/app/constants/leads';

@Injectable({
  providedIn: 'root'
})

export class CotacaoVidaService implements CotacaoRamoService {

  public _leadsCadastrados = LeadsConstants.leads;
  public _seguradorasBase = IntegracaoConstants.seguradoras;
  private _coberturasMulti = IntegracaoConstants.tipoCoberturaMultiTxt;
  private _sexo = IntegracaoConstants.sexoTxt;
  private _profissoes = IntegracaoConstants.profissoesTxt;
  private _estadoCivil = IntegracaoConstants.estadoCivilTxt;
  private _stepsId = IntegracaoConstants.stepsId;
  private _ramos = IntegracaoConstants.ramos;
  private _packageType = IntegracaoConstants.packageType;

  private tipoReq = 5;
  public dadosUser: any = []

  constructor(private utilsService: UtilsService, private apiUsuario: ApiUsuarioService, public recalculoService: RecalculoService) { }

  async setDadosUser(){
    try{
        let dt = await this.apiUsuario.getListCfgsSegs()

        console.log(dt)

        if (dt)
          this.dadosUser = dt
        else
          this.dadosUser = false
    }catch(err){
      console.log(err)
       this.dadosUser = false
    }
  }

  sessoesPDF() {
    return [{
      code: 1,
      description: "Segurado",
      selected: true
    },
    {
      code: 3,
      description: "Coberturas",
      selected: true
    },
    {
      code: 4,
      description: "Cálculos com erro",
      selected: true
    }]
  }

  setComissaoDefault(su) {
    su.percComissao = su.percComissaoVida;
    su.percDesconto = su.percDescontoVida;
    return su;
  }

  setCoberturas(v, obj) {
    return null;
  }

  getMessageCalcExtension(subramo?) {
    return 'VER_CALCULO_VIDA';
  }

  getColumnsGridCalculosVersao() {
    return [
      'seguradora',
      'premio',
      'premioMensal',
      'comissao',
      'morte',
      'morteAcidental',
      'invalidezPermanente',
      'doencasGraves',
      'funeral',
      'tempo'
    ];
  }

  getCalcObject(draft, seguradoras, coberturas) {

    let obj = JSON.parse(JSON.stringify(draft));
    let propertiesToDelete = [
      'automoveis',
      'placa',
      'chassi',
      'modelo',
      'results',
      'loaded',
      'vigenciaFim',
      'updatedAt',
      'textoBusca',
      'renovaIdIntegracao',
      'createdAt',
      'corretoraId',
      'negocioRenocacaoId',
      'status'
    ];

    propertiesToDelete.map((pd) => delete obj[pd]);

    // limpa segurado
    const seguradoPropsDelete = [
      'dataPrimHabil',
      'residBairro',
      'residCidade',
      'residLogradouro',
      'residNumero',
      'residUF',
      'tipoPessoa'
    ];

    seguradoPropsDelete.forEach(prop => obj.segurado && delete obj.segurado[prop]);

    // delete obj.segurado.dataPrimHabil;
    // delete obj.segurado.residBairro;
    // delete obj.segurado.residCidade;
    // delete obj.segurado.residLogradouro;
    // delete obj.segurado.residNumero;
    // delete obj.segurado.residUF;
    // delete obj.segurado.tipoPessoa;

    // limpa configuracoes

    const configsPropsDelete = [
      'assist24hs',
      'despesaFixa',
      'fidelidade',
      'imovelLogradouro',
      'imovelNumero',
      'imovelComplemento',
      'imovelBairro',
      'imovelCidade',
      'imovelUF',
      'imovelUso',
      'imovelTipoResidencia',
      'imovelConstrucao',
      'imovelOcupacao',
      'imovelObjetoSegurado',
      'imovelAtividadeProfissionalLocal',
      'imovelPossuiAlarme',
      'imovelPossuiVigilancia24hs',
      'isDanosIncendioRaioExplosao',
      'isDanosEletricos',
      'isDanosImpactoVeiculo',
      'isDanosAluguel',
      'isDanosRoubo',
      'isDanosAlagamento',
      'isDanosAluguel',
      'isDanosDesmoronamento',
      'isDanosEletricos',
      'isDanosImpactoVeiculo',
      'isDanosIncendioRaioExplosao',
      'isDanosMateriais',
      'isDanosRoubo',
      'responsabilidadeCivil',
      'vidros'
    ];

    configsPropsDelete.forEach(prop => obj.configuracoes && delete obj.configuracoes[prop]);

    // delete obj.configuracoes.assist24hs;
    // delete obj.configuracoes.despesaFixa;
    // delete obj.configuracoes.fidelidade;
    // delete obj.configuracoes.imovelLogradouro;
    // delete obj.configuracoes.imovelNumero;
    // delete obj.configuracoes.imovelComplemento;
    // delete obj.configuracoes.imovelBairro;
    // delete obj.configuracoes.imovelCidade;
    // delete obj.configuracoes.imovelUF;
    // delete obj.configuracoes.imovelUso;
    // delete obj.configuracoes.imovelCep;
    // delete obj.configuracoes.imovelAlarme;
    // delete obj.configuracoes.imovelTipoResidencia;
    // delete obj.configuracoes.imovelConstrucao;
    // delete obj.configuracoes.imovelOcupacao;
    // delete obj.configuracoes.imovelObjetoSegurado;
    // delete obj.configuracoes.imovelAtividadeProfissionalLocal;
    // delete obj.configuracoes.imovelPossuiAlarme;
    // delete obj.configuracoes.imovelPossuiVigilancia24hs;
    // delete obj.configuracoes.isDanosIncendioRaioExplosao;
    // delete obj.configuracoes.isDanosEletricos;
    // delete obj.configuracoes.isDanosImpactoVeiculo;
    // delete obj.configuracoes.isDanosAluguel;
    // delete obj.configuracoes.isDanosRoubo;

    // limpa
    // delete obj.configuracoes.isDanosAlagamento;
    // delete obj.configuracoes.isDanosAluguel;
    // delete obj.configuracoes.isDanosDesmoronamento;
    // delete obj.configuracoes.isDanosEletricos;
    // delete obj.configuracoes.isDanosImpactoVeiculo;
    // delete obj.configuracoes.isDanosIncendioRaioExplosao;
    // delete obj.configuracoes.isDanosMateriais;
    // delete obj.configuracoes.isDanosRoubo;
    // delete obj.configuracoes.responsabilidadeCivil;
    // delete obj.configuracoes.vidros;

    obj.ramo = this._ramos.VIDA;
    obj.tipo = 5;

    let hoje = new Date();
    let vigIni = new Date(obj.vigenciaIni);
    let limiteRetroativo: any = new Date();
    limiteRetroativo = this.utilsService.editarData({ data: limiteRetroativo, operacao: "-", dia: 15, mes: 0, ano: 0 });

    if (limiteRetroativo)
      if (limiteRetroativo.getTime() > vigIni.getTime()) {
        obj.vigenciaIni = hoje.toISOString();
      }

    for (let prop in obj) {
      if (obj === null)
        delete obj[prop];
    }

    obj.calculos = seguradoras.habilitadas.filter(function (cfg) { return cfg.ativo });
    obj.calculos = obj.calculos.map(function (el) {
      let objCalc = { ...el, ...this.coberturasCalc };
      objCalc.percComissao = el.percCom ? parseInt(el.percCom) : 0;
      objCalc.percDesconto = el.percDesc ? parseInt(el.percDesc) : 0;
      objCalc.percAgenciamento = el?.percAgenciamento ? parseInt(el.percAgenciamento) : 0;

      this.utilsService.clearCfgSegToCalc(objCalc);

      if (!objCalc.libertyCodigoEstabelecimento)
        objCalc.libertyCodigoEstabelecimento = null;
      if (!objCalc.libertyDescontoRegional)
        objCalc.libertyDescontoRegional = 1;

      delete objCalc.ID;

      return objCalc;

    }.bind(this));

    return obj;

  }

  coberturasMerge(coberturas, obj) {
    return coberturas;
  }

  getSeguradorasStatus(seguradorasUser, servicesInfos, ramo) {
    let segStatus = servicesInfos.calculos.vida.individual;

    for (let idx in segStatus) {

      let options = segStatus[idx];

      let reduced = options.reduce((filtered, option) => {
        let seg = seguradorasUser.find((cfgUser) => { return option.id == cfgUser.seguradora });

        if (seg && seg.seguradora != this._seguradorasBase.AZUL.id && seg.seguradora != this._seguradorasBase.ALIRO.id) {

          seg.idIntegracaoCfg = seg.ID;
          seg.idIntegracaoCfgSeg = seg.ID;

          seg.login = seg.usuario;

          seg.percCom = seg.percComissao;
          seg.percDesc = seg.percDesconto;

          let cfgSegConfig = { ...option, ...seg };

          filtered.push(cfgSegConfig);

        }

        return filtered;

      }, []);

      segStatus[idx] = reduced;
      segStatus[idx].sort(function (a, b) {
        if (a.nome > b.nome) {
          return 1;
        }
        if (a.nome < b.nome) {
          return -1;
        }
        return 0;
      });

    }

    return segStatus;
  }

  async getCoberturasUser(api) {
    return null;
  }

  matStepRoute(action, selectedStep, flags) {
    switch (selectedStep) {
      case this._stepsId.formulario:
        if (action == "next") {
          return "enviarCalculo";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.simuladorComissoes:
        if (action == "next") {
          return "simuladorComissoes";
        } else if (action == "previous") {
          return "resultados";
        }
        break;
      case this._stepsId.enviarCalculo:
        if (action == "next") {
          return "calcular";
        } else if (action == "previous") {
          if (flags.simuladorComissoes) {
            return "simuladorComissoes";
          } else if (flags.calcular) {
            return "resultados";
          } else {
            return "formulario"
          }
        }
        break;
    }
  }

  //adaptado para o apice
  createDraft(negocio, opt?) {
    if (!negocio)
      negocio = new CalcVida();
    negocio.tipo = this.tipoReq;
    if (opt) {
      if (opt.seguradoUrl) {
        let propertiesToCopy = [
          "nome",
          "tipoPessoa",
          "cpfCnpj",
          "estadoCivil",
          "dataNasc",
          "sexo",
          "fone1",
          "fone",
          "email",
          "cep",
          "residLogradouro",
          "residNumero",
          "residCidade",
          "residBairro",
          "complemento",
          "residUF"
        ];
        propertiesToCopy.forEach((p) => {
          negocio.segurado[p] = opt.seguradoUrl[p];
        });
        negocio.segurado.seguradoUrl = true;
      }
      if (opt.negocioUrl) {
        negocio.negocioId = opt.negocioUrl;
      }
    }
    return negocio;
  }

  createVersions(arrayVersions) {
    return arrayVersions.map((v) => {

      //Se não tiver versão, é calculo antigo, e respectivamente é a primeira versão, ou
      //Versão é igual a 0 e foi somente salvo, sem calcular, não deveria acessar a tela de resultado, somente o formulario.
      if (!v.versao && v.versao !== 0)
        v.versao = 1;

      this.addVersion(v);

      this.utilsService.setResultsAll(v);
      this.utilsService.sortResults(v);

      return v;

    });
  }

  private addVersion(v) {

    v.vigenciaIniTxt = this.utilsService.dateStringToTxt(v.vigenciaIni);
    v.vigenciaFimTxt = this.utilsService.dateStringToTxt(v.vigenciaFim);

    v.numeroRenovacaoTxt = v.numeroRenovacao ? v.numeroRenovacao : "Não informada";

    v.segurado.cpfCnpjTxt = this.utilsService.cpfCnpj(v.segurado.cpfCnpj);
    v.segurado.dataNascTxt = this.utilsService.dateStringToTxt(v.segurado.dataNasc);
    v.segurado.sexoTxt = this._sexo[v.segurado.sexo];
    v.segurado.profissaoTxt = this._profissoes[v.segurado.profissao];
    v.segurado.estadoCivilTxt = this._estadoCivil[v.segurado.estadoCivil];

    v.segurado.cepTxt = this.utilsService.formatCep(v.segurado.cep);

    v.results = new CalcsResults();

    this.updateResults(v);

  }

  adicionarLeads(v){
    var leads = this._leadsCadastrados;
    var storage:any = localStorage.getItem('nao-exibir-leads' )

    if (typeof storage == 'string')
       storage = JSON.parse(storage)

    storage = Array.isArray(storage) ? storage  : []

    leads = leads.filter(item =>{
       var temConfig = this.dadosUser.find(c => c.seguradora == item.seguradoraId)

       let temCalcuSeg = v.calculos.find(c => c.seguradora == item.seguradoraId)

       if (temConfig.ativo || temCalcuSeg)
          return false

       let seg = storage.find(s => s.seg == item.seguradoraId )

       return seg ? false : true
    })

    leads.forEach(l =>{
      if (l.ramos.vida)
          v.results.main["successes"].push(l)
    })
  }

  public updateResults(v) {
    v.calculos.map((vr) => {
      this.extractResultsVida(v, vr);
    });

    this.utilsService.setResultsAll(v);
    this.utilsService.sortResults(v);
    this.adicionarLeads(v)
  }

  private extractResultsVida(v, calc) {

    delete calc['corretora'];

    let id = 0;

    v.configuracoes.qtdDiariasTxt = v.configuracoes.DIT?.qtdDiarias ? this.getDIT(v.configuracoes.DIT?.qtdDiarias) : "--";
    v.configuracoes.valorDITTxtRS = v.configuracoes.DIT?.valor ? this.utilsService.numberFormat(v.configuracoes.DIT?.valor, true) : "";

    v.configuracoes.qtdDoencasTxt = v.configuracoes.isDoencasGravesGrupo?.qtdDoencas ? this.getDoencas(v.configuracoes.isDoencasGravesGrupo?.qtdDoencas) : "--";
    v.configuracoes.valorDoencasGravesTxt = v.configuracoes.isDoencasGravesGrupo?.valor ? this.utilsService.numberFormat(v.configuracoes.isDoencasGravesGrupo?.valor) : v.configuracoes?.doencaGraves ? this.utilsService.numberFormat(v.configuracoes?.doencaGraves) : v.configuracoes?.doencasGraves ? this.utilsService.numberFormat(v.configuracoes?.doencasGraves) : "--";
    v.configuracoes.valorDoencasGravesTxtRS = v.configuracoes.isDoencasGravesGrupo?.valor ? this.utilsService.numberFormat(v.configuracoes.isDoencasGravesGrupo?.valor, true) : v.configuracoes?.doencaGraves ? this.utilsService.numberFormat(v.configuracoes?.doencaGraves, true) : v.configuracoes?.doencasGraves ? this.utilsService.numberFormat(v.configuracoes?.doencasGraves, true) : "";

    v.configuracoes.fumanteTxt = v.configuracoes.fumante ? "Sim" : "Não";
    v.configuracoes.funeralTxt = v.configuracoes.funeral?.tipo ? this.getFuneral(v.configuracoes.funeral?.tipo) : "--";
    v.configuracoes.funeralTxtCob = v.configuracoes.funeral?.valor ? this.utilsService.numberFormat(v.configuracoes.funeral?.valor, true) : "";
    v.configuracoes.invalidezPermanenteTxt = v.configuracoes.isAppInvalidez ? this.utilsService.numberFormat(v.configuracoes.isAppInvalidez) : "--";
    v.configuracoes.invalidezPermanenteTxtRS = v.configuracoes.isAppInvalidez ? this.utilsService.numberFormat(v.configuracoes.isAppInvalidez, true) : "--";
    v.configuracoes.morteTxtRS = v.configuracoes.isAppMorte ? this.utilsService.numberFormat(v.configuracoes.isAppMorte, true) : "--";
    v.configuracoes.morteAcidentalTxtRS = v.configuracoes.isAppMorteAcidental ? this.utilsService.numberFormat(v.configuracoes.isAppMorteAcidental, true) : "--";
    v.configuracoes.isDespesasMedicasHospitalaresTxtRS = v.configuracoes.isDespesasMedicasHospitalares ? this.utilsService.numberFormat(v.configuracoes.isDespesasMedicasHospitalares, true) : "";
    v.configuracoes.isInvalidezDoencaTxtRS = v.configuracoes.isInvalidezDoenca ? this.utilsService.numberFormat(v.configuracoes.isInvalidezDoenca, true) : "";

    let esporte = ''
    if (v.configuracoes.praticaEsporteRadical) {
      if(typeof v.configuracoes.praticaEsporteRadical === 'number') {
        esporte = this.getEsportes(v.configuracoes.praticaEsporteRadical);
        esporte = esporte.toLowerCase();
        esporte = esporte[0].toUpperCase() + esporte.substring(1);
      }
    }
    v.configuracoes.esportesRadicaisTxt = v.configuracoes.praticaEsporteRadical ? esporte : "--";

    let iterarCalcs = calc.resultados;

    if (!Array.isArray(iterarCalcs) || iterarCalcs.length == 0) {
      let copyToResult = JSON.parse(JSON.stringify(calc));
      copyToResult.principal = true;
      iterarCalcs = [copyToResult];
    }

    if (iterarCalcs) {

      iterarCalcs.map(function (vrr) {
        id = id + 1;
        vrr.ramo = this.ramo;
        vrr.retorno = calc.retorno;
        vrr.idPacote = calc.seguradora + "-" + id;
        vrr.nome = this.utilsService.getSegNameById(calc.seguradora);
        vrr.logo = this.utilsService.getPathLogoById(calc.seguradora);
        vrr.tempoResposta = calc.tempoResposta ? calc.tempoResposta / 1000 : "";
        vrr.isError = calc.erros ? calc.erros.length > 0 : false;
        vrr.seguradora = calc.seguradora;

        vrr.isComissaoAdicional = vrr.comissaoAdicional ? true : false;
        if (vrr.isComissaoAdicional)
          vrr.comissaoAdicionalTxt = this.utilsService.numberFormat(vrr.comissaoAdicional);

        if (vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Principal";
        } else if (!vrr.principal && !vrr.identificacao) {
          vrr.identificacao = "Alternativo";
        }

        //a = 'Roubo/Furto/ colisão/Danos';

        vrr.identificacaoLim = vrr.identificacao;

        if (vrr.identificacaoLim.length >= 24) {
          vrr.identificacaoLim = vrr.identificacaoLim.replace(/(.{0,22}).*/, "$1...")
          //console.log(vrr.identificacaoLim.replace(/(.{0,22}).*/,"$1...").length);
        }


        try{
          debugger
          if (this.dadosUser){
            const temp = this.dadosUser.find(seg => seg.seguradora == calc.seguradora)
            console.log(temp);
            ///RECALCULO///
            if (temp?.admin )
              this.recalculoService.habilitaRecalculo(vrr, calc, v);
            else if (!temp?.admin && !temp?.configsSeg?.configsGlobais)
              this.recalculoService.habilitaRecalculo(vrr, calc, v);
            ///RECALCULO///
          }
        }catch(err){
          console.log(err);
        }

        //debugger;
        vrr.idIntegracaoCfgSeg = calc.idIntegracaoCfgSeg;
        if (vrr.hasOwnProperty('idCalculo'))
          vrr.nroCalculo = vrr.idCalculo;

        vrr.premioMensalTxt = vrr.premioMensal ? this.utilsService.numberFormat(parseFloat(vrr.premioMensal)) : "--";
        vrr.premioMensalTxtRS = vrr.premioMensal ? this.utilsService.numberFormat(parseFloat(vrr.premioMensal), true) : "--";

        vrr.premioTxt = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio)) : "--";
        vrr.premioTxtRS = vrr.premio ? this.utilsService.numberFormat(parseFloat(vrr.premio), true) : "--";

        if (vrr.coberturas) {
          //vrr.coberturas.percComissao = vrr.coberturas.percComissao ? vrr.coberturas.percComissao : "--";
          vrr.coberturas.percDescontoTxt = vrr.coberturas.percDesconto ? (vrr.coberturas.percDesconto + "%") : "--";
          vrr.coberturas.percDesconto = vrr.coberturas.percDesconto ? vrr.coberturas.percDesconto : "--";
          vrr.coberturas.percComissaoTxt = vrr.coberturas.percComissao ? (vrr.coberturas.percComissao + "%") : "--";
          vrr.coberturas.percAgenciamentoTxt = vrr.coberturas?.percAgenciamento ? (vrr.coberturas.percAgenciamento + "%") : "--";

          vrr.coberturas.morteTxt = vrr.coberturas.morte ? this.utilsService.numberFormat(vrr.coberturas.morte) : "--";
          vrr.coberturas.morteTxtRS = vrr.coberturas.morte ? this.utilsService.numberFormat(vrr.coberturas.morte, true) : "--";

          vrr.coberturas.morteAcidentalTxt = vrr.coberturas.morteAcidental ? this.utilsService.numberFormat(vrr.coberturas.morteAcidental) : "--";
          vrr.coberturas.morteAcidentalTxtRS = vrr.coberturas.morteAcidental ? this.utilsService.numberFormat(vrr.coberturas.morteAcidental, true) : "--";

          vrr.coberturas.invalidezPermanenteTxt = vrr.coberturas.invalidezPermanente ? this.utilsService.numberFormat(vrr.coberturas.invalidezPermanente) : "--";
          vrr.coberturas.invalidezPermanenteTxtRS = vrr.coberturas.invalidezPermanente ? this.utilsService.numberFormat(vrr.coberturas.invalidezPermanente, true) : "--";

          vrr.coberturas.funeralTxt = typeof vrr.coberturas.funeral == "boolean" ? (vrr.coberturas.funeral ? "Sim" : "Não") : "--";

          if (typeof vrr.coberturas.funeral == "boolean")
            vrr.coberturas.funeralTxt = vrr.coberturas.funeral ? "Sim" : "Não";
          else if (typeof vrr.coberturas.funeral == "number")
            vrr.coberturas.funeralTxt = vrr.coberturas.funeral > 0 ? "Sim" : "Não";
          else
            vrr.coberturas.funeralTxtCob = "--";

          if (typeof vrr.coberturas.funeral == "boolean")
            vrr.coberturas.funeralTxtCob = vrr.coberturas.funeral ? "Sim" : "Não";
          else if (typeof vrr.coberturas.funeral == "number")
            vrr.coberturas.funeralTxtCob = this.utilsService.numberFormat(vrr.coberturas.funeral, true); // vrr.coberturas.funeral ? "Sim" : "Não"
          else
            vrr.coberturas.funeralTxtCob = "";

          let doenca = vrr.coberturas.doencaGraves ? vrr.coberturas.doencaGraves : vrr.coberturas.doencasGraves ? vrr.coberturas.doencasGraves : undefined;
          // vrr.coberturas.doencasGravesTxt = vrr.coberturas.doencaGraves ? this.utilsService.numberFormat(vrr.coberturas.doencaGraves) : "--";
          // vrr.coberturas.doencasGravesTxtRS = vrr.coberturas.doencaGraves ? this.utilsService.numberFormat(vrr.coberturas.doencaGraves, true) : "";


          vrr.coberturas.isDespesasMedicasHospitalaresTxt = vrr.coberturas.isDespesasMedicasHospitalares ? this.utilsService.numberFormat(vrr.coberturas.isDespesasMedicasHospitalares) : "--";
          vrr.coberturas.isDespesasMedicasHospitalaresTxtRS = vrr.coberturas.isDespesasMedicasHospitalares ? this.utilsService.numberFormat(vrr.coberturas.isDespesasMedicasHospitalares, true) : "";

          vrr.coberturas.isInvalidezDoencaTxt = vrr.coberturas.isInvalidezDoenca ? this.utilsService.numberFormat(vrr.coberturas.isInvalidezDoenca) : "--";
          vrr.coberturas.isInvalidezDoencaTxtRS = vrr.coberturas.isInvalidezDoenca ? this.utilsService.numberFormat(vrr.coberturas.isInvalidezDoenca, true) : "";

          if (typeof vrr.coberturas.DIT?.qtdDiarias === 'string') {
            vrr.coberturas.diariasDITTxt = vrr.coberturas.DIT?.qtdDiarias ? vrr.coberturas.DIT?.qtdDiarias : "";
          } else {
            vrr.coberturas.diariasDITTxt = vrr.coberturas.DIT?.qtdDiarias ? this.getDIT(vrr.coberturas.DIT.qtdDiarias) : "";
          }
          vrr.coberturas.valorDITTxt = vrr.coberturas.DIT?.valor ? this.utilsService.numberFormat(vrr.coberturas.DIT.valor) : "--";
          vrr.coberturas.valorDITTxtRS = vrr.coberturas.DIT?.valor ? this.utilsService.numberFormat(vrr.coberturas.DIT.valor, true) : "";

          vrr.coberturas.esportesRadicaisTxt = vrr.coberturas.praticaEsporteRadical ? this.getEsportes(vrr.coberturas.praticaEsporteRadical) : vrr.coberturas.esporteRadical ? this.getEsportes(vrr.coberturas.esporteRadical) : "";

          if (typeof vrr.coberturas?.isDoencasGravesGrupo?.qtdDoencas === 'string') {
            vrr.coberturas.qtdDoencasGravesTxt = vrr.coberturas?.isDoencasGravesGrupo?.qtdDoencas ? vrr.coberturas.isDoencasGravesGrupo.qtdDoencas : "";
          } else {
            vrr.coberturas.qtdDoencasGravesTxt = vrr.coberturas?.isDoencasGravesGrupo?.qtdDoencas ? this.getDoencas(vrr.coberturas.isDoencasGravesGrupo.qtdDoencas) : "";
          }

          vrr.coberturas.valorDoencasTxt = vrr.coberturas?.isDoencasGravesGrupo?.valor ? this.utilsService.numberFormat(vrr.coberturas.isDoencasGravesGrupo.valor) : doenca ? this.utilsService.numberFormat(doenca) : "--";
          vrr.coberturas.valorDoencasTxtRS = vrr.coberturas?.isDoencasGravesGrupo?.valor ? this.utilsService.numberFormat(vrr.coberturas.isDoencasGravesGrupo.valor, true) : doenca ? this.utilsService.numberFormat(doenca, true) : "--";

        } else {
          vrr.coberturas = {};
        }

        vrr.msErros = calc.erros;
        vrr.msAlertas = calc.alertas;

        if (vrr.alertas)
          vrr.msAlertas = Array.isArray(vrr.msAlertas) ? vrr.msAlertas.concat(vrr.alertas) : vrr.alertas;

        let verificarPremio = vrr.premio && vrr.premio > 0;
        let verificarPremioMensal = vrr.premioMensal && vrr.premioMensal > 0;

        if (vrr.retorno && !vrr.isError && !verificarPremio && !verificarPremioMensal) {
          vrr.isError = true;
          vrr.msErros = ["Houve um erro não identificado ao realizar este cálculo."];
        }

        let arrToAdd = vrr.isError ? "errors" : "successes";
        if (vrr.hasOwnProperty('packageType') && Object.values(this._packageType).includes(vrr.packageType)) {
          if (vrr.packageType === this._packageType.PRINCIPAL) {
            vrr.isAlternative = !vrr?.selected;
            v.results[vrr?.selected ? 'main' : 'alternatives'][arrToAdd].push(vrr);
          } else if (vrr.packageType === this._packageType.MENSAL) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            vrr.isAlternative = true;
            v.results.alternatives[arrToAdd].push(vrr);
          }
        } else {
          let isPorAssinatura = this.utilsService.isCalcPorAssinatura(calc.seguradora);

          if (isPorAssinatura) {
            vrr.isPorAssinatura = true;
            v.results.porAssinatura[arrToAdd].push(vrr);
          } else {
            let isAlternative = this.utilsService.isCalcAutoAlternative(calc.seguradora);
  
            if (vrr.principal && !isAlternative) {
              vrr.isAlternative = false;
              v.results.main[arrToAdd].push(vrr);
              //} else if((!calc.retornoErro && !vrr.isError) || isAlternative) { //comentar com o cleiton q essa var retornoerro vem smp true
            } else if ((!vrr.isError) || isAlternative) {
              vrr.isAlternative = true;
              v.results.alternatives[arrToAdd].push(vrr);
            }
          }
        }
      }.bind(this));

    }



  }

  getFuneral(v) {
    let funeral = IntegracaoConstants.assistFuneralViewValue
    let funCob = funeral.find(f => {
      return f.value === v
    })

    return funCob?.viewValue ? funCob?.viewValue : ''
  }

  getDIT(dit) {
    let dits = IntegracaoConstants.diariasDITViewValue
    let ditCob = dits.find(d => {
      return d.value === dit
    })

    return ditCob?.viewValue ? ditCob?.viewValue : ''
  }

  getDoencas(valor) {
    let doencas = IntegracaoConstants.doencasGravesViewValue
    let doencasCob = doencas.find(d => {
      return d.value === valor
    })

    return doencasCob?.viewValue ? doencasCob?.viewValue : ''
  }

  getEsportes(valor) {
    let esportes = IntegracaoConstants.esportesRadicaisViewValue
    let esporteCob = esportes.find(e => {
      return e.value === valor
    })

    return esporteCob?.viewValue ? esporteCob?.viewValue : ''
  }

}
